import { render, staticRenderFns } from "./InfoRolType.vue?vue&type=template&id=60990294&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60990294')) {
      api.createRecord('60990294', component.options)
    } else {
      api.reload('60990294', component.options)
    }
    module.hot.accept("./InfoRolType.vue?vue&type=template&id=60990294&", function () {
      api.rerender('60990294', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/wizardFlow/components/InfoRolType.vue"
export default component.exports